import React from 'react'
import i18n from '../../../../../../../lib/i18n'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { addSlidePptx } from '../../../../../actions';
import { notification } from 'antd';


const limitCount = 150;

function UploadSliderPptx({ countImgs = 0 }) {
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch()
  const slider = useSelector(state => state.slider.slider)
  const onChange = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      if (file.type !== 'application/vnd.openxmlformats-officedocument.presentationml.presentation' && !file.name.endsWith('.pptx')) {
        throw new Error('Only PPTX allowed');
      }

      await dispatch(addSlidePptx(file, slider.id));
    } catch (error) {
      api.error({
        message: i18n('sl_slide_pptx_title') || 'Error',
        description: i18n('sl_slide_pptx_msg') || 'Error uploading PPTX',
      })
    }
  }

  return (
    <label>
      {contextHolder}
      {i18n('sl_add_slide_pptx') || 'Upload PPTX'}
      {countImgs < limitCount && <input style={{ display: 'none' }} type='file' accept='.pptx,application/vnd.openxmlformats-officedocument.presentationml.presentation' onChange={onChange} />}
    </label>
  )
}

export default UploadSliderPptx
